import {observable, action, runInAction} from 'mobx'
import auth from '../utils/auth'
import accountApi from '../apis/accountAPI'
import {permissionKey, permissionOrder, USER_INFO_STORAGE_KEY, USER_PERMISSION_KEY} from '../constants/appConstant'
import history from '../routes/history'
import * as AppUrl from '../constants/appUrl'
import alertMessage from '../utils/alertMessage'

const storage = window.localStorage

export default class AccountStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable hasLoggedOn = false
  @observable userCode = ''
  @observable permissionKeys = []
  @observable pspToken = ''
  @observable accountInfos = {}
  @observable reimbursementTotalAmount = '' //待报销金额
  @observable pendingApprovalCount = ''   //待审批数量
  @observable title403 = 'Sorry, you have no permission'
  @observable menuBread = []
  @observable reportFetchFlag = null

  /* menu start */
  @observable selectedItem = 'home'

  @action onSetSelectItemAction() {
    this.selectedItem = storage.getItem('selectedItem')
  }

  @action setSeletedItem(key) {   //20200904 add
    this.selectedItem = key.toString()
    storage.setItem('selectedItem', key)
  }

  @action setReportName(key) {   //20200904 add
    storage.setItem('defaultReportName', key)
  }

  @action reportFetchFlagChange() {
    this.reportFetchFlag = Math.random()
  }

  /* menu end */

  /* save search form */
  @action setTabsSearchForm(values) {
    storage.setItem('tabsSearchForm', JSON.stringify(values))
  }

  @observable authInfo = {
    accessToken: '',
    pspToken: '',
    permissions: ''
  }

  @action
  getPermissionKeys() {
    this.permissionKeys = auth.getPermissions()
  }

  @action
  login(userCode, password) {
    storage.setItem('selectedItem', 'home')//20200904 add
    return new Promise((resolve, reject) => {
      this.isFetching = true
      accountApi
        .login(userCode, password)
        .then(res => {
          const data = res.data
          if (!data.token) {
            reject()
            return
          }
          runInAction(() => {
            const {userCode, token, pspToken, permissionKeys} = data
            this.accountInfos = {data: {name: userCode, token: token}}
            this.hasLoggedOn = true
            this.userCode = userCode
            this.permissionKeys = permissionKeys
            this.pspToken = pspToken
            this.isFetching = false
            auth.authorize(token, pspToken, permissionKeys)
          })
          resolve()
        })
        .catch(reject)
    })
  }

  @action
  logout(userId) {
    storage.removeItem('selectedItem')
    storage.removeItem('defaultReportName')

    return new Promise((resolve, reject) => {
      accountApi
        .logout(userId)
        .then(() => {
          runInAction(() => {
            // auth.authorize('')
            storage.removeItem(USER_INFO_STORAGE_KEY)
            storage.removeItem(USER_PERMISSION_KEY)
            storage.removeItem('userCode')
            history.push('/login')
          })
          resolve()
        })
        .catch(reject)
    })
  }

  @action
  async validateCode(code) {
    try {
      const response = await accountApi.validateCode(code)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.onGetChatBiPermission(data=> {
            if (response.data.data.userAuthorizationDetailInfoVO.powerUser) {
              if (!data) {
                const chatbiIndex = permissionKey.indexOf('chatbi')
                if (chatbiIndex > -1) {
                  permissionKey.splice(chatbiIndex, 1)
                }
              }
              auth.authorize(response.data.data?.token, '', permissionKey)
              this.accountInfos = {
                data: {
                  name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                  isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                  token: response.data.data.token
                }
              }
              storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
              storage.setItem('selectedItem', 'home')
              history.push(AppUrl.HOME)
            } else if (response.data.data.userAuthorizationDetailInfoVO.permissions?.MENU?.length > 0) {
              const ownerPermissionKey = []
              let finalKeyList
              // if (response.data.data.userAuthorizationDetailInfoVO.permissions.MENU) {
              const ownerPermissionList = this.flatTree(response.data.data.userAuthorizationDetailInfoVO.permissions.MENU)
              ownerPermissionList.map(item => {
                return ownerPermissionKey.push(item.key)
              })
              if (!data) {
                const chatbiIndex = ownerPermissionKey.indexOf('chat')
                if (chatbiIndex > -1) {
                  ownerPermissionKey.splice(chatbiIndex, 1)
                }
              }
              auth.authorize(response.data.data?.token, '', ownerPermissionKey)
              this.accountInfos = {
                data: {
                  name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                  isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                  token: response.data.data.token
                }
              }
              storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
              finalKeyList = [...new Set(permissionOrder)].filter(item =>
                ownerPermissionKey.includes(item)
              )
              storage.setItem('selectedItem', finalKeyList[0] === 'home' ? 'home' : `${finalKeyList[0]}`)
              history.push(finalKeyList[0] === 'home' ? AppUrl.HOME : `/${finalKeyList[0]}`)

            } else if (response.data.data.userAuthorizationDetailInfoVO.permissions?.MENU?.length === 0 || Object.keys(response.data.data.userAuthorizationDetailInfoVO.permissions).length === 0) {
              auth.authorize(response.data.data?.token, '', null)
              this.accountInfos = {
                data: {
                  name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                  isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                  token: response.data.data.token
                }
              }
              storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
              history.push(AppUrl.FORBIDDEN)
            }
          })
        } else if (response.data.code === 403) {
          this.title403 = response.data.message
          history.push(AppUrl.FORBIDDEN)
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  flatTree(tree) {  //tree to arr
    return tree.reduce((res, item) => {
      if (item.children && item.children.length) {
        res = res.concat(this.flatTree(item.children))
      } else {
        res.push(item)
      }
      return res
    }, [])
  }

  @action
  onMenuClick(params) {
    this.menuBread = params
  }


  @action
  async onLoginByPwd(params) {
    this.isFetching = true
    try {
      const response = await accountApi.loginByPwd(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          if (response.data.data.userAuthorizationDetailInfoVO.powerUser) {
            auth.authorize(response.data.data?.token, '', permissionKey)
            this.accountInfos = {
              data: {
                name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                id: response.data.data.userAuthorizationDetailInfoVO?.id,
                isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                token: response.data.data.token
              }
            }
            storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
            storage.setItem('selectedItem', 'home')
            history.push(AppUrl.HOME)
          } else if (response.data.data.userAuthorizationDetailInfoVO.permissions?.MENU?.length > 0) {
            const ownerPermissionKey = []
            let finalKeyList
            // if (response.data.data.userAuthorizationDetailInfoVO.permissions.MENU) {
            const ownerPermissionList = this.flatTree(response.data.data.userAuthorizationDetailInfoVO.permissions.MENU)
            ownerPermissionList.map(item => {
              return ownerPermissionKey.push(item.key)
            })
            // ownerPermissionKey.sort(function (a, b) {
            //   return permissionKey.indexOf(a) - permissionKey.indexOf(b)
            // })
            // }
            auth.authorize(response.data.data?.token, '', ownerPermissionKey)
            this.accountInfos = {
              data: {
                name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                token: response.data.data.token
              }
            }
            storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
            finalKeyList = [...new Set(permissionOrder)].filter(item =>
              ownerPermissionKey.includes(item)
            )
            storage.setItem('selectedItem', finalKeyList[0] === 'home' ? 'home' : `${finalKeyList[0]}`)
            history.push(finalKeyList[0] === 'home' ? AppUrl.HOME : `/${finalKeyList[0]}`)

          } else if (response.data.data.userAuthorizationDetailInfoVO.permissions?.MENU?.length === 0 || Object.keys(response.data.data.userAuthorizationDetailInfoVO.permissions).length === 0) {
            auth.authorize(response.data.data?.token, '', null)
            this.accountInfos = {
              data: {
                name: response.data.data.userAuthorizationDetailInfoVO?.shortName,
                isPowerUser: response.data.data.userAuthorizationDetailInfoVO?.powerUser,
                token: response.data.data.token
              }
            }
            storage.setItem('accountInfos', JSON.stringify(this.accountInfos))
            history.push(AppUrl.FORBIDDEN)
          }
        } else if (response.data.code === 401) {
          alertMessage.error(response.data.message + '')
        } else if (response.data.code === 403) {
          this.title403 = response.data.message
          history.push(AppUrl.FORBIDDEN)
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @observable
  themeStyle = {}
  @action
  async onGetThemeStyle() {
    this.isFetching = true
    try {
      const response = await accountApi.getThemeStyle()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          const configData = response.data.data.configData
          this.themeStyle = JSON.parse(configData || '{}')
          storage.setItem('themeStyle', configData)
        } else if (response.data.code === 401) {
          alertMessage.error(response.data.message + '')
        } else if (response.data.code === 403) {
          this.title403 = response.data.message
          history.push(AppUrl.FORBIDDEN)
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onUpdatePwdByUser(params) {
    this.isFetching = true
    try {
      const response = await accountApi.updatePwdByUser(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Change Password Success！')
        } else {
          alertMessage.error('Failed！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable isTabHas = false

  @action
  setIsTabHas(value) {
    this.isTabHas = value
  }
  // 是否有聊天机器人权限
  @observable chatBiPermission = false
  @action
  async onGetChatBiPermission() {
    try {
      const response = await accountApi.getChatBiPermission()
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        if (code === 0) {
          this.chatBiPermission = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
      })
    }
  }
}
